import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
  sequence: Yup.number()
    .required('Order is required')
    .min(1, 'Order must be at least 1'),
});

// Fixed Custom input component
const CustomInput = ({ field, form, parentClass, className, disabled, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${className || 'form-control'} ${hasError ? 'error' : ''}`}
        disabled={disabled}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreateEra extends Component {
  getInitialValues = () => {
    const { mode, initialValues } = this.props;

    if (mode === 'EDIT' && initialValues) {
      return {
        id: initialValues.id,
        name: initialValues.name || '',
        description: initialValues.description || '',
        sequence: initialValues.sequence || 1,
      };
    }
    return {
      name: '',
      description: '',
      sequence: 1,
    };
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (this.props.mode === 'EDIT') {
      this.props.onEdit({
        ...values,
        id: this.props.initialValues?.id
      });
    } else {
      this.props.onCreate(values);
    }
    setSubmitting(false);
  };

  render() {
    const { mode, isCreating, accessMode, initialValues } = this.props;
    const isViewMode = accessMode === 'view';
    const isEditMode = accessMode === 'edit';

    return (
      <section className="well create-piece">
        <Formik
          initialValues={this.getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Name</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="name"
                    type="text"
                    placeholder="Name"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                <div className="col-md-3">
                  <label>Description</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="description"
                    type="text"
                    placeholder="Description"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="sequence"
                    type="number"
                    placeholder="Sequence"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>

                {isEditMode && (
                  <div className="create-piece__btn-container">
                    <button
                      className="cus-btn-primary btn-block btn-lg"
                      type="submit"
                      disabled={isCreating || isSubmitting}
                    >
                      {isCreating || isSubmitting ? (
                        <span className="spinner" />
                      ) : (
                        <span>{mode === 'EDIT' ? 'Update' : 'Create'}</span>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </section>
    );
  }
}

export default CreateEra;
